import React from 'react';
import { IconWarning } from '@americanexpress/dls-icons';
import { Heading } from '@americanexpress/dls-react';

export const ErrorPage = () => (
  <main>
    <div className="border text-align-center pad-4" role="alert">
      <div className="pad-responsive-lr stack">
        <IconWarning size="xl" color="critical" />
        <Heading level={1} className="margin-1-b" variant="sans-small-regular">
          We&apos;re sorry, we aren&apos;t able to load this page.
        </Heading>
        <p className="body">
          The data you requested didn&apos;t load correctly.
        </p>
      </div>
      <hr className="margin-3-tb" />
      <a
        className="btn btn-primary margin-responsive-lr"
        href="https://www.americanexpress.com"
        style={{ textDecoration: 'none' }}
      >
        Go to Homepage
      </a>
    </div>
  </main>
);

export default ErrorPage;
